<div [formGroup]="group" [attr.class]="styleForm">
    <label *ngIf="label" [attr.for]="controlName">{{ label }}</label>
    <label *ngIf="labelLeft" [attr.for]="controlName" class="label-left">{{ labelLeft }}</label>
    <div [class.has-icon]="icon" class="field" [class.label-left]="labelLeft">
        <fa-icon *ngIf="icon && (icon | iconNameToDefinition)" [icon]="icon | iconNameToDefinition"></fa-icon>
        <input type="number"
               [attr.tabindex]="index"
               [attr.min]="min"
               [attr.max]="max"
               class="number-field"
               [disabled]="disabled"
               [attr.placeholder]="placeholder"
               [formControlName]="controlName"
               (keyup)="disabled ? false : onKeyup($event)"
               (keydown)="disabled ? false : onKeydown($event)"
               (keypress)="disabled ? false : onlyNumberKey($event)"
               (focus)="onFocus($event)"
               #field>
        <div class="spinner-button increase"
             (click)="disabled ? false : increase()"
             [class.unactive]="testMax() || disabled"><fa-icon [icon]="iconPlus"></fa-icon></div>
        <div class="spinner-button decrease"
             (click)="disabled ? false : decrease()"
             [class.unactive]="testMin() || disabled"><fa-icon [icon]="iconMinus"></fa-icon></div>
        <ng-content select=".input-end-position"></ng-content>
    </div>
</div>
